module.exports = __webpack_public_path__ + "static/media/edit.a849704b.svg";